import React, { useMemo } from "react";
import PropTypes from "prop-types";

import DialogForm from "ui/Dialog";
import Button from "ui/Button";

import useExecuteMutation from "hooks/useExecuteMutation";

import {
  ASSIGN_VERSION_XML_FILE_MUTATION,
  READ_VERSION_FILES_QUERY_NAME,
  UNASSIGN_VERSION_XML_FILE_MUTATION,
} from "graphqlQueries/versions";

const AssignVersionFileDialog = (props) => {
  const { versionId, selected, onSuccessFunc, onClose } = props;

  const values = {
    id_version: versionId,
    id_xml: selected,
  };

  const onSuccessCallback = () => {
    onSuccessFunc();
    onClose();
  };

  const mutationProps = useMemo(
    () => ({
      refetchQueries: [READ_VERSION_FILES_QUERY_NAME],
      onSuccessCallback,
    }),
    [],
  );

  const { executeMutation: assignMutation, loading: assignLoading } =
    useExecuteMutation(ASSIGN_VERSION_XML_FILE_MUTATION, mutationProps);

  const { executeMutation: unassignMutation, loading: unassignLoading } =
    useExecuteMutation(UNASSIGN_VERSION_XML_FILE_MUTATION, mutationProps);

  const renderActionsFunc = (onClose) => {
    return (
      <div className="assign-version-dialog-actions">
        <Button
          id="close-version-selected-file-button"
          variant="text"
          onClick={onClose}
        >
          Cancel
        </Button>
        <div className="assign-version-dialog-submit-actions">
          <Button
            id="version-unassign-selected-file-button"
            loading={unassignLoading}
            onClick={() => unassignMutation(values)}
            color="error"
          >
            Unassign selected
          </Button>
          <Button
            id="version-assign-selected-file-button"
            loading={assignLoading}
            onClick={() => assignMutation(values)}
            color="success"
          >
            Assign selected
          </Button>
        </div>
      </div>
    );
  };

  return (
    <DialogForm
      title="Assign selected files"
      subTitle="Please select an action to mass assign selected files or unassigned."
      initialValues={values}
      isLoading={assignLoading || unassignLoading}
      renderActionsFunc={renderActionsFunc}
      onClose={onClose}
      onSubmit={() => {}}
    />
  );
};

AssignVersionFileDialog.propTypes = {
  versionId: PropTypes.number.isRequired,
  selected: PropTypes.arrayOf(PropTypes.number).isRequired,
  onSuccessFunc: PropTypes.func,
  onClose: PropTypes.func.isRequired,
};

export default AssignVersionFileDialog;
